import React from "react";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import PropTypes from "prop-types";

const styles = (theme) => ({
  grid: {
    minHeight: "100vh",
    background: theme.palette.background.default,
  },
  paper: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
});

const Page = ({ children, classes, style }) => {
  return (
    <div>
      <Grid
        container
        spacing={3}
        className={classes.grid}
        justifyContent="center"
        alignItems="center"
        style={style}
      >
        <Grid size={{ xs: 4 }}>
          <Paper className={classes.paper} elevation={4}>
            {children}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

Page.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  style: PropTypes.object,
};

export default withStyles(styles)(Page);
